<fieldset
  class="labelled-area"
  [ngClass]="{ 'enable-scrolling': !!maxHeight, readonly: readonly }"
  [ngStyle]="{ 'max-height': maxHeight }"
>
  <legend class="labelled-area-title" [innerHTML]="title"></legend>
  <ng-content></ng-content>
</fieldset>
